import LineFunctionResult from './LineFunctionResult.js';
import {nicelyRounded} from '../../util/CommonUtils.js';

export default class LineFunctionPercentile {
  constructor(labelPattern, params) {
    this._labelPattern = labelPattern;
    this._percintile = params.percentile;
  }

  /**
   * Inclusive percentile. Inspiration came from org.apache.commons.math3.stat.descriptive.rank.Percentile
   * @param x array of x values of the plot, is ignored
   * @param y array of y values
   * @param xAxis x & y of the visualization
   * @returns {LineFunctionResult[]}
   */
  calculateLine(x, y, xAxis) {
    const arr = y.slice().sort((a, b) => a-b)
    const n = arr.length;
    let result;
    const percentileReal = this._percintile * (n + 1) - 1;
    if(percentileReal <= 0)
      result = arr[0];
    else if(percentileReal >= (n-1))
      result = arr[n-1];
    else {
      const percentileFloored = Math.floor(percentileReal);
      const diff = percentileReal - percentileFloored;
      const lower = arr[percentileFloored];
      const upper = arr[percentileFloored + 1];
      result = lower + diff * (upper - lower);
    }
    return [new LineFunctionResult([[xAxis[0], result], [xAxis[1], result]], this._labelPattern.replace('${value}', nicelyRounded(result)))];
  }
}